import { TableColumnConfig } from '@weave/design-system';
import { Dispute } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';

export const generateColumns: TableColumnConfig<Dispute>[] = [
  {
    Header: 'Created',
    id: 'createdAt',
    accessor: (dispute) => dispute.createdAt,
  },
  {
    Header: 'Updated',
    id: 'updatedAt',
    accessor: (dispute) => dispute.updatedAt,
  },
  {
    Header: 'Amount',
    id: 'amount',
    accessor: (dispute) => dispute.amount,
  },
  {
    Header: 'Reason',
    id: 'reason',
    accessor: (dispute) => dispute.reason,
  },
  {
    Header: 'Status',
    id: 'status',
    accessor: (dispute) => dispute.status,
  },
];
